module.exports = __webpack_public_path__ + "img/ic_account@2x.68233efb.png";